module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/bme_off-cb56841a5c9ee21bd4eaeb70ada24a2e.gif";